/* eslint-disable import/prefer-default-export */

import { useCallback, useMemo } from 'react';
import { getCountryOptions } from '../services/countryService';

export const useCountryOptions = () => {
  const countryOptions = useMemo(
    () => getCountryOptions().map((country) => ({
      id: country.code,
      ...country
    })),
    []
  );

  const filterCountryOption = useCallback(
    (searchText = '') => {
      const text = searchText.toLowerCase();

      return countryOptions.filter(
        (option) => option.name_es?.toLowerCase().includes(text)
          || option.name_en?.toLowerCase().includes(text)
          || option.dial_code?.toLowerCase().includes(text)
          || option.code?.toLowerCase().includes(text)
      );
    },
    [countryOptions]
  );

  return {
    countryOptions,
    filterCountryOption
  };
};
